import { useCheckoutProStore } from "@/store/checkout-pro";
import { useMagasinStore } from "@/store/magasin";

export const usePageCommanderPro = () => {
  const checkoutProStore = useCheckoutProStore();
  const magasinStore = useMagasinStore();

  const { name: magasinName } = storeToRefs(magasinStore);
  const { checkout, unauthProducts } = storeToRefs(checkoutProStore);

  const { removeUnauthProducts } = checkoutProStore;

  return {
    magasinName,
    checkout,
    unauthProducts,
    removeUnauthProducts
  }
}